const $inject = ['$scope', 'moment'];

const lbTripOptionsCarFormCtrl = function ($scope, moment) {
  let vm = this;

  const apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
  const displayDateFormat = 'ddd Do MMM, YYYY';

  $scope.$watch('vm.searches', validateSearches, true);

  function validateSearches(searches) {
    _.forEach(searches, (search, searchIndex) => {
      let dateFromMoment = moment(search.car.pickUp.Date, displayDateFormat);
      let dateToMoment = moment(search.car.dropOff.Date, displayDateFormat);

      if(dateToMoment.isBefore(dateFromMoment)) {
        search.car.dropOff.Date = search.car.pickUp.Date;
      }
    });
  }
};

lbTripOptionsCarFormCtrl.$inject = $inject;

export default lbTripOptionsCarFormCtrl;



// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsCarFormCtrl.js